// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CouponEnrollmentDemographicsUpdateProgramIdDemographicsUpdateResponse {
    static getAttributeTypeMap() {
        return CouponEnrollmentDemographicsUpdateProgramIdDemographicsUpdateResponse.attributeTypeMap;
    }
}
CouponEnrollmentDemographicsUpdateProgramIdDemographicsUpdateResponse.discriminator = undefined;
CouponEnrollmentDemographicsUpdateProgramIdDemographicsUpdateResponse.additionalProperties = false;
CouponEnrollmentDemographicsUpdateProgramIdDemographicsUpdateResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "EnrollmentResultModel"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
];
//# sourceMappingURL=couponEnrollmentDemographicsUpdateProgramIdDemographicsUpdateResponse.js.map